module.exports = __webpack_public_path__ + "static/img/jianshiIcon.bdcdba4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jianshiIcon.png
// module id = i8Jq
// module chunks = 0